module.exports = __webpack_public_path__ + "frontend-assets/img/ab_card.6bb74574.png";